// you may also like
$(document).ready(function() {
// Clear local storage for 'buttonCounts'
//localStorage.removeItem('buttonCounts');
var buttonCounts = JSON.parse(localStorage.getItem('buttonCounts')) || {};
$('.quick-add__submit').click(function() {
        var buttonIndex = $('.quick-add__submit').index(this);
        var count = buttonCounts[buttonIndex] || 0;
        count++;
        buttonCounts[buttonIndex] = count;
        localStorage.setItem('buttonCounts', JSON.stringify(buttonCounts));
        if (count >= 6) {
            $(this).prop('disabled', true);
        }
    });
    $('.quick-add__submit').each(function(index) {
        var buttonIndex = index;
        var count = buttonCounts[buttonIndex] || 0;

        if (count >= 6) {
            $(this).prop('disabled', true);
        }
    });
});
// shop the look
$(document).ready(function() {
// Clear local storage for 'buttonCounts'
//localStorage.removeItem('buttonCounts');
var buttonCounts = JSON.parse(localStorage.getItem('buttonCounts')) || {};
$('.shopthelook_add-to-cart').click(function() {
        var buttonIndex = $('.shopthelook_add-to-cart').index(this);
        var count = buttonCounts[buttonIndex] || 0;
        count++;
        buttonCounts[buttonIndex] = count;
        localStorage.setItem('buttonCounts', JSON.stringify(buttonCounts));
        if (count >= 5) {
            $(this).prop('disabled', true);
        }
    });
    $('.shopthelook_add-to-cart').each(function(index) {
        var buttonIndex = index;
        var count = buttonCounts[buttonIndex] || 0;

        if (count >= 5) {
            $(this).prop('disabled', true);
        }
    });
});
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});


// document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
//   summary.setAttribute('role', 'button');
//   summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

//   if(summary.nextElementSibling.getAttribute('id')) {
//     summary.setAttribute('aria-controls', summary.nextElementSibling.id);
//   }

//   summary.addEventListener('click', (event) => {
//     const clickedDetails = event.currentTarget.closest('details');

//     // Toggle aria-expanded attribute
//     clickedDetails.setAttribute('open', !clickedDetails.hasAttribute('open'));
//     event.currentTarget.setAttribute('aria-expanded', clickedDetails.hasAttribute('open'));

//     // Remove open attribute from other details elements
//     document.querySelectorAll('[id^="Details-"] details').forEach((details) => {
//       if (details !== clickedDetails) {
//         details.removeAttribute('open');
//       }
//     });
//   });

//   if (summary.closest('header-drawer')) return;
//   summary.parentElement.addEventListener('keyup', onKeyUpEscape);
// });



//Navigation hover
let items=document.querySelector(".header__inline-menu").querySelectorAll("details");
var header = document.querySelector(".header");
//console.log(items)
items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    header.classList.add("header-bg");
    item.querySelector("div").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      header.classList.remove("header-bg");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      header.classList.remove("header-bg");
    });
  });
});
//Child open on click
// const subchildNav = document.querySelectorAll('.subchild_linklist');

// subchildNav.forEach(nav => {
//   nav.querySelector('span').addEventListener('click', () => {
//     nav.querySelector('div').classList.add('subchild-nav');
//   });
// });
//Child back button
const back_buttons = document.querySelectorAll(".subchild_back");

back_buttons.forEach(back_button => {
  back_button.addEventListener("click", back_to_child);
});

function back_to_child() {
  this.parentNode.classList.remove('subchild-nav');
}

// const childItems = document.querySelector(".header__inline-menu").querySelectorAll("detail-child");

// childItems.forEach(childItem => {
//   childItem.closest("li").addEventListener("mouseover", () => {
//     const items = document.querySelector(".header__inline-menu").querySelectorAll("details");
//     items[0].setAttribute("open", true);
//     const elements = document.querySelectorAll('.list-unstyled');
//     for (let i = 0; i < elements.length; i++) {
//       elements[i].style.display = 'none';
//     }
//     const getId = childItem.closest("li").getAttribute('aria-controls');
//     const targetElement = document.getElementById(getId);
//     targetElement.style.display = "flex";
    
//   });

//   childItem.closest("li").addEventListener("mouseleave", () => {
//     const getId = childItem.closest("li").getAttribute('aria-controls');
//     const targetElement = document.getElementById(getId);
//     targetElement.style.display = "none";
//   });
// });
// document.querySelectorAll('.child_linklist').forEach((summary) => {
//   summary.addEventListener('mouseover', (event) => {
//     const elements = document.querySelectorAll('.list-unstyled');
//     for (let i = 0; i < elements.length; i++) {
//       elements[i].style.display = 'none';
//     }
//     var get_id = summary.getAttribute('aria-controls');
//     var target_element = document.getElementById(get_id);
//     target_element.style.display = "flex";
//   });
  // summary.addEventListener('mouseout', (event) => {
  //   var get_id = summary.getAttribute('aria-controls');
  //   var target_element = document.getElementById(get_id);
  //   target_element.style.display = "none";
  // });
//});
// document.querySelectorAll('.child_linklist').forEach((summary) => {
//   summary.addEventListener('click', (event) => {
//     const elements = document.querySelectorAll('.list-unstyled');
//     for (let i = 0; i < elements.length; i++) {
//       elements[i].style.display = 'none';
//     }
//     var get_id = summary.getAttribute('aria-controls');
//     var target_element = document.getElementById(get_id);
//     target_element.style.display = "flex";
//   });
// });
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};
Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};


Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {

        
        if(detailsElement.hasAttribute('open') && summaryElement.classList.contains('first_child_mobile')){
          const summaryCust = document.querySelectorAll('.first_child_mobile');
          summaryCust.forEach((nav, index) => {
            nav.parentNode.removeAttribute('open');
          });
          if (!summaryElement.parentNode.hasAttribute('open')) {
            summaryElement.parentNode.setAttribute('open', '');
          }
        }
        if(detailsElement.hasAttribute('open') && summaryElement.classList.contains('last_child_mobile')){
          const summaryCustLast = document.querySelectorAll('.last_child_mobile');
          summaryCustLast.forEach((navlast, index) => {
            navlast.parentNode.removeAttribute('open');
          });
          if (!summaryElement.parentNode.hasAttribute('open')) {
            summaryElement.parentNode.setAttribute('open', '');
          }
        }
        
        
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    
    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    if (!this.sliderControlWrapper) return;
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

    
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    
    
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
  
  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.slider.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }
          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
 new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
 setTimeout(function(){
let product_slider = document.querySelector('product-recommendations').querySelector('.product-grid');
var swiper = new Swiper(product_slider, {
   slidesPerView: "auto",  
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
     });
   
    let media_sliders = []; // Array to store swiper instances

    const media_slider = () => {
      let media_sliderElements = document.querySelector('.related-products').querySelectorAll('.mediaSwiper');
      media_sliderElements.forEach((slider, index) => {
        // this bit checks if there's more than 1 slide, if there's only 1 it won't loop
        let sliderLength = slider.children[0].children.length;
        let result = (sliderLength > 1) ? true : false;
    
        const swiper = new Swiper(slider, {
          slidesPerView: 1,
          spaceBetween: 24,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
    
        media_sliders.push(swiper); // Store swiper instance in array
      });
    }
    
    window.addEventListener('load', () => {
      media_slider();
    
      const handleWindowResize = () => {
        if (window.innerWidth < 750) {
          media_sliders.forEach((swiper) => {
            swiper.destroy(); // Destroy swiper instances below 750 device width
          });
          media_sliders = []; // Clear the array
        } else if (media_sliders.length === 0) {
          // Reinitialize swiper instances above 750 device width only if the array is empty
          media_slider();
        }
      };
    
      handleWindowResize(); // Call the function initially
    
      window.addEventListener('resize', () => {
        handleWindowResize(); // Call the function on window resize
      });
    });
   
    }, 4000);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

//Shop the Look popup
class CustomDrawerComponent extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#custom-drawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const lookbookLinks = document.querySelectorAll('.custom-drawer-trigger');
    lookbookLinks.forEach((lookbookLink) => {
      lookbookLink.addEventListener('click', (event) => {
        event.preventDefault();
        const drawerId = lookbookLink.dataset.drawer;
        const drawer = document.getElementById(drawerId);
        this.open(drawer);
      });
    });
  }

  open(drawer) {
    setTimeout(() => {drawer.classList.add('animate', 'active')});
    document.body.classList.add('overflow-hidden');
  }

  close() {
    const activeDrawers = document.querySelectorAll('.custom-drawer-main.active');
    activeDrawers.forEach((drawer) => {
      drawer.classList.remove('active');
    });
    document.body.classList.remove('overflow-hidden');
  }
}
customElements.define('custom-drawer', CustomDrawerComponent);
//Size Guide popup
class SizeGuideComponent extends HTMLElement {
    constructor() {
    super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#custom-drawer-Overlay').addEventListener('click', this.close.bind(this));
       this.setHeaderCartIconAccessibility();
    }
  
    setHeaderCartIconAccessibility() {
        const lookbookLink = document.querySelector('.size-guide-trigger');
       lookbookLink.addEventListener('click', (event) => {
          event.preventDefault();
         this.open(lookbookLink);
      });
    }
    open(triggeredBy) {
      setTimeout(() => {this.classList.add('animate', 'active')});
      document.body.classList.add('overflow-hidden');
    }
    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }
customElements.define('size-guide-drawer', SizeGuideComponent);
// Mobile otp verify
class LoginOTPVerifier extends HTMLElement {
    // constructor() {
    // super();
    //   this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    //   this.querySelector('#custom-drawer-Overlay').addEventListener('click', this.close.bind(this));
    //    this.setHeaderCartIconAccessibility();
    // }
  
    // setHeaderCartIconAccessibility() {
    //     const lookbookLink = document.querySelector('#send_otp_btn');
    //    lookbookLink.addEventListener('click', (event) => {
    //       event.preventDefault();
    //      this.open(lookbookLink);
    //   });
    // }
    // open(triggeredBy) {
    //   setTimeout(() => {this.classList.add('animate', 'active')});
    //   document.body.classList.add('overflow-hidden');
    // }
    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }
customElements.define('login-otp-drawer', LoginOTPVerifier);
//Feature Collection Slider
class FeatureCollectionComponent extends HTMLElement {
  constructor() {
    super();
    this.load();
  }
  load(){
    let product_slider = this.querySelector('.product-grid');
    var swiper = new Swiper(product_slider, {
      slidesPerView: "auto"
    });
  }
}

// new cart you may also like 
var swiper = new Swiper(".mySwiper_new", {
      slidesPerView: 2,
      spaceBetween: 30,
      resistanceRatio : 0.85,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        clickable: true,
      },
      breakpoints: {        
        750: {
            slidesPerView: 3,
            spaceBetween: 30,
            resistanceRatio: 0.85
        },
        980: {
            slidesPerView: 4,
            spaceBetween: 30,
            resistanceRatio: 0.85
        },
        1280: {
            slidesPerView: 6,
            spaceBetween: 30,               
            resistanceRatio : 0.85
        }
       
    },
   });

customElements.define('feature-collection', FeatureCollectionComponent);
// beauty clp categories
var swiper = new Swiper(".category_slider", {
  slidesPerView: 4,
  spaceBetween: 10,
  loop: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 6,
    },
  },
});
//Collection navigation slider
let toolbar_nav = document.querySelector('.toolbar-nav');
var toolbar_nav_col = new Swiper(toolbar_nav, {
    slidesPerView: "auto",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      clickable: true,
    },
});

//Collection product slider
const media_slider_col = ()=>{
	let media_slider_col = document.querySelectorAll('.mediaSwiper_col');
	media_slider_col.forEach((slider, index)=>{
    // this bit checks if there's more than 1 slide, if there's only 1 it won't loop
		let sliderLength = slider.children[0].children.length
		let result = (sliderLength > 1) ? true : false
		const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 30,
            
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          breakpoints: {
           767: {
               pagination: {  
                 el: ".swiper-pagination",
                clickable: false,
              }
            }
          }
		});	
	});
}
window.addEventListener('load', media_slider_col)

let media_sliders = []; // Array to store swiper instances

const media_slider = () => {
  let media_sliderElements = document.querySelectorAll('.mediaSwiper');
  media_sliderElements.forEach((slider, index) => {
    // this bit checks if there's more than 1 slide, if there's only 1 it won't loop
    let sliderLength = slider.children[0].children.length;
    let result = (sliderLength > 1) ? true : false;

    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      keyboard: {
        enabled: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        767: {
          pagination: {
            el: ".swiper-pagination",
            clickable: false,
          },
        },
      },
    });

    media_sliders.push(swiper); // Store swiper instance in array
  });
}

window.addEventListener('load', () => {
  media_slider();

  const handleWindowResize = () => {
    if (window.innerWidth < 750) {
      media_sliders.forEach((swiper) => {
        swiper.destroy(); // Destroy swiper instances below 750 device width
      });
      media_sliders = []; // Clear the array
    } else if (media_sliders.length === 0) {
      // Reinitialize swiper instances above 750 device width only if the array is empty
      media_slider();
    }
  };

  handleWindowResize(); // Call the function initially

  window.addEventListener('resize', () => {
    handleWindowResize(); // Call the function on window resize
  });
});


// const media_slider = () => {
//   let media_sliders = []; // Array to store swiper instances

//   let mediaSliderElements = document.querySelectorAll(".mediaSwiper");
//   mediaSliderElements.forEach((slider, index) => {
//     let sliderLength = slider.children[0].children.length;
//     let result = sliderLength > 1 ? true : false;

//     const swiper = new Swiper(slider, {
//       slidesPerView: 1,
//       spaceBetween: 30,
//       keyboard: {
//         enabled: true,
//       },
//       pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//       },
//       breakpoints: {
//         767: {
//           pagination: {
//             el: ".swiper-pagination",
//             clickable: false,
//           },
//         },
//       },
//     });

//     media_sliders.push(swiper); // Store swiper instance in array
//   });

//   return media_sliders; // Return array of swiper instances
// };

// window.addEventListener("load", () => {
//   let sliders = media_slider(); // Get array of swiper instances

//   let cardHeadingLinks = document.querySelectorAll(".hover_slider_active");
//   cardHeadingLinks.forEach((link) => {
//     link.addEventListener("mouseenter", () => {
//       if (!isAutoplayActive) {
//         let closestSlider = link.querySelector(".mediaSwiper");
//         if (closestSlider) {
//           let closestSwiper = sliders.find((swiper) => swiper.el === closestSlider);
//           if (closestSwiper) {
//             closestSwiper.autoplay.start(); // Start autoplay for the closest swiper slider
//             isAutoplayActive = true;
//             closestSwiper.params.autoplay.delay = 1000; // Set autoplay delay for the closest swiper slider
//           }
//         }
//       }
//     });

//     link.addEventListener("mouseleave", () => {
//       if (isAutoplayActive) {
//         sliders.forEach((swiper) => {
//           if (swiper.autoplay.running) {
//             swiper.slideTo(0); // Stop autoplay by sliding to the first slide for all sliders
//             swiper.autoplay.stop();
//             isAutoplayActive = false;
//           }
//         });
//       }
//     });
//   });
// });


// let blog_tag = document.querySelector('.mySwiper1');
// var swiper = new Swiper(blog_tag, {
//   slidesPerView: 'auto',
//   watchSlidesVisibility: true,
//   spaceBetween: 0,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//     clickable: true,
//   },
//    breakpoints: {
//     320: {
//       slidesPerView: 3     
//     },
//     767: {
//       slidesPerView: 5  
//     },
//     1399: {
//       slidesPerView: 6      
//     }
//   }
// });
let blog_tag = document.querySelector('.mySwiper1');
var swiper1 = new Swiper(blog_tag, {
    slidesPerView: 3.5,
    spaceBetween: 15,
    resistanceRatio : 0,
    navigation: {
      nextEl: ".blog_next",
      prevEl: ".blog_prev",
      clickable: true,
    },
    breakpoints: {        
        750: {
            slidesPerView: 3,
            spaceBetween: 5,
            resistanceRatio: 0.85
        },
        980: {
            slidesPerView: 'auto',
            spaceBetween: 5,
            resistanceRatio: 0.85
        },
        1280: {
            slidesPerView: 'auto',
            spaceBetween: 0,               
            resistanceRatio : 0
        }
    },
    keyboard: {
        enabled: true,
     }
});

let blog_slider = document.querySelector('.blogslider');
var swiper2 = new Swiper(blog_slider, {
  slidesPerView: 1.50,
  spaceBetween: 30,
  navigation: {
    nextEl: ".blog_next",
    prevEl: ".blog_prev",
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1.70,
      spaceBetween: 10
    },
    767: {
      slidesPerView: 1.50,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20
    }
  }
});

//Scroll down on similar product button
$(document).ready(function() {
  $('.similar-products').click(function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('product-recommendations').offset().top
    }, 1000);
  });
});

// mobile toolbar search close event
$(document).ready(function() {
  $('.modal__close-button').click(function() {
    $('details').removeAttr('open');
  });
});

//cart page check box check product remove
$(document).ready(function() {
  var toAdd = new Array();
  var items1 = [];
 $('.custIn-all').change(function() {
  if ($(this).is(':checked')) {
    $('.custIn').prop('checked', true);
    $('.custIn').parent().parent().addClass('selected');
    $('.custIn').each(function(index) {
      $value = $(this).parent().parent().data('variant');
      toAdd.push({
        variant_id: $value,
        quantity_id: 0
      });
    });
  } else {
    $('.custIn').prop('checked', false);
    $('.custIn').parent().parent().removeClass('selected');
    $('.custIn').each(function(index) {
      $value = $(this).parent().parent().data('variant');
      items1 = items1.filter(function(item) {
        return item.id !== $value;
      });
    });
  }
});
  
  $('input:checkbox.custIn').change(function() {
      // Check if all "custIn" checkboxes are checked
  var allChecked = $('input:checkbox.custIn:checked').length === $('input:checkbox.custIn').length;
   if(allChecked == false){
    $('.custIn-all').prop('checked', false); 
   }else{
    $('.custIn-all').prop('checked', allChecked); 
   }
    if ($(this).is(':checked')) {
      $(this).parent().parent().addClass('selected');
      $value = $(this).parent().parent().data('variant');
      toAdd.push({
        variant_id: $value,
        quantity_id: 0
      });
    } else {
      $(this).parent().parent().removeClass('selected');
      $value = $(this).parent().parent().data('variant');
      items1 = items1.filter(function(item) {
        return item.id !== $value;
      });
    }
  });
  
  function moveAlong(){
    if (toAdd.length) {
      var request = toAdd.shift();
      var tempId= request.variant_id;
      var tempQty = request.quantity_id;
      var params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity='+tempQty+'&id='+tempId,
        dataType: 'json',
        success: function(line_item) {
            //console.log("success!");
            moveAlong();
            //alert("test");

              loader.style.display = "block"; 
              setTimeout(() => {
                loader.style.display = "none"; 
              }, 10000); 

        },
        error: function() {
            //console.log("fail");
            moveAlong();
        }
      };
      $.ajax(params);
    }
  };
  
  $("#deletePro").click(function(){
  if ($(".custIn-all").is(':checked')) {
  const variantIds = [];
  const customeremail = $(".custIn-all").data('email'); // make sure this is defined

  $('.custIn:checked').each(function () {
    const variantId = $(this).data('variantid');
    if (variantId) variantIds.push(variantId);
  });

  // Step 1: Clear Shopify cart
  $.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    dataType: 'json',
    success: function () {
      // Step 2: Loop through each selected variant and call your API
      variantIds.forEach(function (variantId) {
        $.ajax({
          type: 'POST',
          url: westside_url + 'api/frontcartremove',
          data: {
            id: variantId,
            email: customeremail
          },
          success: function (data) {
            console.log(`✅ Removed variant ${variantId} via frontcartremove API`, data);
          },
          error: function (err) {
            console.error(`❌ Failed to remove variant ${variantId}`, err);
          }
        });
      });

      // Optional: reload after delay to let API calls complete
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    },
    error: function () {
      alert('❌ An error occurred while clearing the cart.');
    }
  });
}else{
    moveAlong();
    window.setTimeout(function() {
        window.location.reload(1);
      }, 5000);
  }
    }); 
});

//Navigation custome js for brand menu
// function brand_show_event(hideButton) {
//   var brandList = document.getElementById("brand").getElementsByTagName("li");
//   var numToShow = 6;
//   var numShown = 0;
//   let hiddenCount = 0;
//   for (var i = 0; i < brandList.length; i++) {
//     if (brandList[i].style.display === "none" && numShown < numToShow) {
//       brandList[i].style.display = "block";
//       numShown++;
//     }
//     if (brandList[i].style.display === 'none') {
//       hiddenCount++;
//     }
//   }
//   if (hiddenCount == 0) {
//     hideButton.style.display = "none";
//   }
// }

function brand_show_event(hideButton) {
  var brandList = document.getElementById("brand").getElementsByTagName("li");
  var numToShow = 6;
  var numHidden = 0;

  // Count the number of currently hidden elements
  for (var i = 0; i < brandList.length; i++) {
    if (brandList[i].style.display === "none") {
      numHidden++;
    }
  }

  // If there are at least 6 hidden elements, show the next 6 hidden elements
  if (numHidden >= numToShow) {
    var numToDisplay = Math.min(numToShow, numHidden);
    for (var i = 0; i < brandList.length && numToDisplay > 0; i++) {
      if (brandList[i].style.display === "none") {
        brandList[i].style.display = "block";
        numToDisplay--;
      }
    }
  } else {
    // Hide the first 6 visible elements
    var numToHide = Math.min(numToShow, brandList.length - numHidden);
    for (var i = 0; i < brandList.length && numToHide > 0; i++) {
      if (brandList[i].style.display === "block") {
        brandList[i].style.display = "none";
        numToDisplay--;
      }
    }
  }
}




const myCustomSlider = document.querySelectorAll('.shop-look-mobile');
for( i=0; i< myCustomSlider.length; i++ ) {  
  myCustomSlider[i].classList.add('swiper-container-' + i);
  var slider = new Swiper('.swiper-container-' + i, {
    slidesPerView: 2.5,
    spaceBetween: 16,
    direction: 'horizontal',
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      clickable: true,
    },
     breakpoints: {
      767: {
        slidesPerView: 1,
        direction: 'vertical',
        spaceBetween: 0
      }
  }
  });
}


// //Back button for mobile layout
$(document).ready(function() {
  // Handle click on back button
  $(".backButton").click(function(event) {
    event.preventDefault();

    // Check if there is a previous URL in the history
    if (history.length > 1) {
      // Go back to the previous URL
      history.back();
    } else {
      // If there is no previous URL, redirect to the home page
      window.location.href = "/";
    }
  });


// //Accout toogle
//     // $(".header__icon--account").click(function(event) {
//     //   event.preventDefault();
//     //   $(this).next('ul').toggleClass('active');
//     // });
});


//Boost app custom quick view code
function pfs_add_to_cart(button) {
  //button.preventDefault();
 //alert('hhh');
    var option1 = $(button).parents('#boost-pfs-quickview-cart-form').find('.boost-pfs-quickview-selector-wrapper').find('input[name="option1"]:checked').val();
   var option2 = $(button).parents('#boost-pfs-quickview-cart-form').find('.boost-pfs-quickview-selector-wrapper').find('input[name="option2"]:checked').val();
  var variant = option1 + ' / ' + option2;
  $('.boost-pfs-quickview-variants-selector').find('option').each(function() {
    //alert($(this).attr('data-options'));
    if($(this).attr('data-options') === variant){
      var variant_id = $(this).attr('data-variant-id');
      var items = [{ quantity: 1, id: variant_id }];
      $.ajax({
         type: "POST",
         url: '/cart/add',
         data: { items: items },
         success: function(data) {
           $('#boost-pfs-quickview-cart-btn').addClass('loading');
           setTimeout(function() {
             $('#boost-pfs-quickview-cart-btn').removeClass('loading');
           }, 1000);
           //$('#boost-pfs-quickview-cart-btn').find('#boost-pfs-quickview-cart-btn-text').text('Added');

            $.getJSON('/cart.js', function(cart) {
              $('.cart-count-bubble').find('span').eq(0).html(cart.item_count);
            });
         },
         dataType: 'json'
      });
    }
  });
  
  // var items = [{ quantity: 1, id: variant }];
  // 
}

function pfs_quick_view(button) {
  $('.loadding').show();
  var attr_data = $(button).attr('data-href');
  $.get(attr_data, function (data) {
    $('#collection-quick').find('custom-drawer').html(data);
    setTimeout(function() {
      $('.loadding').hide();
    }, 1000);
  });
  setTimeout(function() {
    $('#drawer-collection-quick').addClass('active');
  }, 500);  
  //var demo = $(button).parents('.boost-pfs-filter-product-bottom-inner').find('.product-form-col').show();
}
function pfs_size_guide(button) {
  $('size-guide-drawer').addClass('active');
}

//Get TCP Login
var utm_source = localStorage.getItem("utm_source");
if(utm_source == 'tcp'){
  //$('.footer  .footer__content-top').find('.footer-block').eq(0).hide();
  $('.download_mob_app').find('p').hide();
  $('.download_mob_app').find('span').hide();
  // $('.mobile_footer').css('display', 'none');
  // $('.footer-block').eq(0).hide();
}



document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.includes('https://www.westside.com/pages/store-locator?webview=true')) {
    var mobileFooter = document.querySelector('.mobile_footer');
    if (mobileFooter) {
      mobileFooter.style.display = 'none';
    }
  }
});

//lehlha App
const queryString = window.location.search;

if (queryString.includes('utm_source=lehlah')) {
  let utm_source_lehlah = '';
  let utm_medium_lehlah = '';
  let utm_content_lehlah = '';

  if (queryString.includes('utm_source')) {
    utm_source_lehlah = queryString.split('utm_source=')[1].split('&')[0];
  }
  if (queryString.includes('utm_medium')) {
    utm_medium_lehlah = queryString.split('utm_medium=')[1].split('&')[0];
  }
  if (queryString.includes('utm_content')) {
    utm_content_lehlah = queryString.split('utm_content=')[1].split('&')[0];
  }

  // Use the variables utm_source, utm_medium, utm_campaign, utm_term, and utm_content as needed
  console.log('utm_source:', utm_source_lehlah);
  console.log('utm_medium:', utm_medium_lehlah);
  console.log('utm_content:', utm_content_lehlah);

  localStorage.setItem('utm_sourcelehlah', utm_source_lehlah);
  localStorage.setItem('utm_mediumlehlah', utm_medium_lehlah);
  localStorage.setItem('utm_contentlehlah', utm_content_lehlah);
}

$(".menu-drawer__menu li").each(function(i) {
    $(this).addClass("id_unique" + i);
});


// added code for pome clp
function redirectToStoreLocator(event) {
  event.preventDefault();
  sessionStorage.setItem("redirectToPome", true);
  window.location.href = "https://www.westside.com/pages/store-locator";
}
document.addEventListener("DOMContentLoaded", function() {
  if (sessionStorage.getItem("redirectToPome")) {
    sessionStorage.removeItem("redirectToPome");
    const pomeButton = document.getElementById("Pome");
    if (pomeButton) {
      pomeButton.click();
      pomeButton.classList.add("active");
    }
  }
});

// login prompt on homepage
const userNameElement = document.querySelector(".user-name");
const popup = document.getElementById("login-popup");
const closeBtn = document.querySelector(".popup .close");

// Check localStorage flag for permanent close
let popupClosed = localStorage.getItem("popupClosed");

// Function to show popup
function showPopup() {
if (!popupClosed) {
popup.style.display = "flex";
}
}

// Function to close popup permanently
function closePopup() {
popup.style.display = "none";
localStorage.setItem("popupClosed", "true");
}

// Logic: show popup only if not logged in AND not permanently closed
if (
(!localStorage.getItem("c_name") ||
(userNameElement && userNameElement.textContent.trim() === "Sign in"))
&& !popupClosed
) {
showPopup();
} else {
popup.style.display = "none"; // hide if logged in
}

// Close on cross click
closeBtn.addEventListener("click", closePopup);

// Optional: Watch for login event → auto-hide popup if c_name gets set
window.addEventListener("storage", (event) => {
if (event.key === "c_name" && event.newValue) {
popup.style.display = "none";
}
});

document.getElementById("login-btn").addEventListener("click",function (){
  //window.location.href = "https://www.westside.com/account/login";
   window.location.href = "https://gcc.westside.com/account/login"
});

// To change the popup text after intervals
const popupText = document.querySelector(".popup-text");
const popupMessages = [
  "Unlock member benefits!",
  "See what you are missing?",
  "Your personal store awaits!"
];

let msgIndex = sessionStorage.getItem("popupMsgIndex");

if (msgIndex === null) {
  msgIndex = Math.floor(Math.random() * popupMessages.length);
  sessionStorage.setItem("popupMsgIndex", msgIndex);
} else {
  msgIndex = parseInt(msgIndex, 10);
}
popupText.textContent = popupMessages[msgIndex];


// size-guide-drawer
document.addEventListener("click", function(e) {
  const trigger = e.target.closest(".size-guide-trigger");
  if (!trigger) return;

  e.preventDefault();

  const drawer = document.querySelector("size-guide-drawer");
  if (drawer) {
    drawer.classList.add("active");
    drawer.setAttribute("open", "true");
  }
});